import { useState } from 'react';
import { FaGlobe, FaCaretDown, FaCaretUp } from 'react-icons/fa';

export default function LanguageToggle({ language, setLanguage }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleLanguage = (lang) => {
    setLanguage(lang);
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block text-left">
      <div>
        <button
          type="button"
          className="flex items-center gap-2 p-2 border rounded-2xl mt-4 shadow-md"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <FaGlobe />
          <span>{language === "English" ? "English" : "Español"}</span>
          {isOpen ? <FaCaretUp /> : <FaCaretDown />}
        </button>
      </div>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-40 bg-white border rounded-md shadow-lg z-10">
          <button
            onClick={() => toggleLanguage("English")}
            className="block w-full text-left px-4 py-2 text-black hover:bg-gray-100"
          >
            English
          </button>
          <button
            onClick={() => toggleLanguage("Spanish")}
            className="block w-full text-left px-4 py-2 text-black hover:bg-gray-100"
          >
            Español
          </button>
        </div>
      )}
    </div>
  );
}
